var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#233544",
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M5.4 5.88a8.99 8.99 0 0 0-1.998 3.464l1.6.924c1.332.77 1.332 2.694 0 3.464l-1.602.924a9.03 9.03 0 0 0 2 3.464l1.601-.924c1.333-.77 3 .192 3 1.732v1.847c1.3.297 2.668.306 4 .002v-1.849c0-1.54 1.667-2.502 3-1.732l1.602.925a8.99 8.99 0 0 0 1.998-3.466l-1.6-.923c-1.333-.77-1.333-2.694 0-3.464l1.601-.925a9.033 9.033 0 0 0-2-3.464l-1.6.925c-1.334.77-3-.193-3-1.732V3.225a8.99 8.99 0 0 0-4-.003v1.85c0 1.54-1.668 2.501-3 1.732L5.4 5.879Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.d54cc5a83ea628e5d0434c5a4b3ff707.svg";
export { ForwardRef as ReactComponent };